// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".group-wrapper[data-v-669139f1] .active-child{background-color:hsla(0,0%,100%,.5)}.centered-input[data-v-669139f1] input{text-align:center}", ""]);
// Exports
module.exports = exports;
